import React from 'react'
import { Input, Select, DatePicker, Space, theme } from 'antd'
import { SearchOutlined, FilterOutlined, CalendarOutlined } from '@ant-design/icons'

const { Option } = Select
const { RangePicker } = DatePicker

const AdmissionsFilters = ({
  searchText,
  setSearchText,
  statusFilter,
  setStatusFilter,
  departmentFilter,
  setDepartmentFilter,
  dateRange,
  setDateRange,
  departments
}) => {
  const { token } = theme.useToken()

  return (
    <div
      style={{
        marginBottom: '24px',
        padding: '16px',
        background: token.colorBgContainer,
        borderRadius: '8px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.03)'
      }}
    >
      <Space wrap style={{ width: '100%', justifyContent: 'space-between' }}>
        <Space wrap>
          <Input
            placeholder='Search by name, ID, or room'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{
              width: 250,
              borderColor: token.colorPrimary
            }}
            prefix={<SearchOutlined style={{ color: token.colorPrimary }} />}
            allowClear
          />

          <Select
            placeholder='Status'
            style={{
              width: 150,
              borderColor: searchText ? token.colorPrimary : undefined
            }}
            value={statusFilter}
            onChange={(value) => setStatusFilter(value)}
            suffixIcon={<FilterOutlined style={{ color: statusFilter !== 'all' ? token.colorWarning : undefined }} />}
          >
            <Option value='all'>All Statuses</Option>
            <Option value='Active'>Active</Option>
            <Option value='Discharged'>Discharged</Option>
          </Select>

          <Select
            placeholder='Department'
            style={{
              width: 200,
              borderColor: departmentFilter !== 'all' ? token.colorPrimary : undefined
            }}
            value={departmentFilter}
            onChange={(value) => setDepartmentFilter(value)}
            suffixIcon={
              <FilterOutlined style={{ color: departmentFilter !== 'all' ? token.colorWarning : undefined }} />
            }
          >
            <Option value='all'>All Departments</Option>
            {departments.map((dept) => (
              <Option key={dept} value={dept}>
                {dept}
              </Option>
            ))}
          </Select>
        </Space>

        <RangePicker
          onChange={(dates) => setDateRange(dates)}
          style={{ width: 300 }}
          suffixIcon={<CalendarOutlined style={{ color: dateRange ? token.colorPrimary : undefined }} />}
        />
      </Space>
    </div>
  )
}

export default AdmissionsFilters
